import { FC } from 'react'
import { Helmet } from 'react-helmet'
import GpsPetitionsList from 'backoffice/components/GpsPetitions/List'
import StatusFilter from 'backoffice/components/GpsPetitions/Filters/StatusFilter'
import { useGetGpsPetitionsQuery } from 'backoffice/components/GpsPetitions/useGpsPetitionsQuery'
import { Params } from 'api/fetch'
import styles from './GpsPetitions.module.scss'

const GpsPetitions: FC = () => {
  const { setQueryParams, currentParams, petitionsQuery } = useGetGpsPetitionsQuery({
    page: '1',
    limit: '10',
  })

  const handleStatusChange = (status: string | null) => {
    setQueryParams((prev) => {
      const newParams: Params = { ...prev, page: '1' }
      if (status) {
        newParams.status = status
      } else {
        delete newParams.status
      }
      return newParams
    })
  }

  return (
    <>
      <Helmet>
        <title>POAP - Manage GPS Petitions</title>
        <meta property="og:title" content="POAP - Manage GPS Petitions" />
      </Helmet>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Manage GPS Petitions</h1>
        <div className={styles.filters}>
          <StatusFilter
            value={(currentParams.status as string) || null}
            onChange={handleStatusChange}
            className={styles.statusFilter}
          />
        </div>
      </div>
      <GpsPetitionsList petitionsQuery={petitionsQuery} setQueryParams={setQueryParams} />
    </>
  )
}

export { GpsPetitions }
